export const ACCESS_DENIED_MESSAGE = "You don't have permission to do this.";

type Problem = { title?: unknown; detail?: unknown };

/**
 * The access-denied toast text: the message, then the API's title / detail when it sent one
 */
export function formatAccessDenied(problem?: Problem | null): string {
  const reason = (value: unknown) =>
    value === undefined || value === null ? "" : String(value).trim();

  const isObject = typeof problem === "object" && problem !== null;
  const title = isObject ? reason(problem.title) : "";
  const detail = isObject ? reason(problem.detail) : "";
  const why = title && detail ? `${title}: ${detail}` : title || detail;

  return why ? `${ACCESS_DENIED_MESSAGE} ${why}` : ACCESS_DENIED_MESSAGE;
}

export function isAccessDenied(error: unknown): boolean {
  return (
    (error as { accessDenied?: unknown } | null | undefined)?.accessDenied ===
    true
  );
}
